import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _Search(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("circle", { cx: 11, cy: 11, r: 7, stroke: "currentColor", strokeWidth: 2 }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: 2, d: "m20 20-3-3" })));
}
const Search = forwardRef(_Search);
export { Search };
